(function ($) {
    $(window).on("load", function () {


        // Set the date we're counting down to
        var countDownDate = new Date("Sep 15, 2020  00:00:00").getTime();
        var counter = document.getElementById("countdownclock");

        if ( counter != null ) {
            // Update the count down every 1 second
            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);


                var html = "<div class='counters'><div class='count-days'>" + days + "</div><div class='count-hours'>" + hours + "</div><div class='count-minutes'>" + minutes + "</div><div class='count-seconds'>" + seconds + "</div></div>";

                // Display the result in the element with id="demo"
                counter.innerHTML = html;

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    counter.innerHTML = "EXPIRED";
                }
            }, 1000);
        }

    });
}) (jQuery);


// Shortcode Countdown
(function ($) {
    $(window).on("load", function () {
        $('.meetingcountdown').each(function(){
            // var id = $(this).data('id');
            var target = $(this).data('to');

        // Set the date we're counting down to
        var countDownDate = new Date( target ).getTime();
        var counter = $(this).get( 0 );

            console.log(countDownDate);
        if ( counter != null ) {
            // Update the count down every 1 second
            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;
                var html = '';
                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    days = '00';
                    hours = '00';
                    minutes = '00';
                    seconds = '00';
                    html = "<p><strong>Event Happening Now</strong></p>";
                }

                html += "<div class='counters'><div class='count-days'>" + days + "</div><div class='count-hours'>" + hours + "</div><div class='count-minutes'>" + minutes + "</div><div class='count-seconds'>" + seconds + "</div></div>";

                // Display the result in the element with id="demo"
                counter.innerHTML = html;


            }, 1000);
        }
        });
    });
}) (jQuery);
